// Easy to read out and type on a phone: no 0/o or 1/l/i look-alikes
const PASSWORD_CHARS = 'abcdefghjkmnpqrstuvwxyz23456789';

// Generate a random password the same way whether a beoordelaar is created by hand
// or imported from a CSV/Excel file
export function genereerWagwoord(length = 8) {
  const values = new Uint32Array(length);
  window.crypto.getRandomValues(values);
  return Array.from(values, v => PASSWORD_CHARS[v % PASSWORD_CHARS.length]).join('');
}
